import PropTypes from 'prop-types';
import Surface from './ui/Surface';

export default function TeamCard({ name, role, bio, credentials, image }) {
  return (
    <Surface as="article" className="flex h-full flex-col overflow-hidden p-0 transition-shadow hover:shadow-md">
      <div className="relative h-56 w-full overflow-hidden bg-cam-blue/20">
        <img
          src={image}
          alt={`${name} headshot`}
          className="h-full w-full object-cover mix-blend-luminosity"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-cam-blue/60" aria-hidden="true" />
      </div>
      <div className="flex flex-1 flex-col p-6">
        <h3 className="text-xl font-semibold text-cam-blue">{name}</h3>
        <p className="mt-1 text-sm font-medium uppercase tracking-wide text-cam-blue/70">{role}</p>
        <p className="mt-3 text-sm text-slate-600">{bio}</p>
        <p className="mt-3 text-xs font-semibold text-slate-500">Credentials: {credentials}</p>
      </div>
    </Surface>
  );
}

TeamCard.propTypes = {
  name: PropTypes.string.isRequired,
  role: PropTypes.string.isRequired,
  bio: PropTypes.string.isRequired,
  credentials: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired
};
